module.exports = __webpack_public_path__ + "static/normal-51aea003131205aef0bd3049ebb16ba8.jpg";